/* util/core */

define(
	'util/core',[
		'jquery'
	],
	function( $ ) {

		'use strict';

		return {

			// Scroll to an element on screen
			// $elm = jQuery element - the element to scroll to
			// pxAbove = int - padding between top of screen and element (defaults to 0)
			scrollToElm: function( $elm, pxAbove ) {
				var topPadding = pxAbove || 0;
				var scrollHeight = $elm.offset().top;
				$( 'html, body' ).animate( { scrollTop: scrollHeight - topPadding }, 'slow' );
			},

			// Returns a class name with no '.'
			// selector = string - the jQuery selector to remove '.' from
			getClassName: function( selector ) {
				return selector.replace( '.', '' );
			},

			// Returns an object containing the current URL's query string
			// Combines values with the same key
			// e.g. 'filter-content-type=photos,videos' instead of form.serialize which will return 'filter-content-type=photos&filter-content-type=videos'
			getQueryStringObject: function (queryString) {
				queryString = typeof queryString !== 'undefined' ? queryString : document.location.search.substr(1);
				queryString = queryString.split('&');

				var query = {};

				for (var i = 0; i < queryString.length; i++) {
					queryString[i] = queryString[i].split('=');

					if (queryString[i].length > 1) {
						var key = decodeURIComponent(queryString[i][0]);
						var val = decodeURIComponent(queryString[i][1]);

						if (query[key]) {
							query[key] += ',' + val;
						} else {
							query[key] = val;
						}
					}
				}

				return query;
			}
		};
	}
);
